(() => {
	angular.module('main').directive('mailInfoModal', mailInfoModal);
	mailInfoModal.$inject = ['settingsService'];

	function mailInfoModal(settingsService) {
		return {
			restrict: 'E',
			scope: {
				mailData: '=',
				onReplySend: '&',
				isLeadArchived: '='
			},
			template: `
                <div id="main-wrapper" class="container">
                    <div id="mailInfoModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <btn-close></btn-close>
                                    <h3 class="modal-title">Mail details</h3>
                                </div>
                                <div class="modal-body modal-contract-body">
                                    <sn-field-info sn-title="From" sn-text="mailData.to === 'me' ? mailData.from : 'me'"></sn-field-info> 
                                    <sn-field-info sn-title="To" sn-text="mailData.to"></sn-field-info>
                                    <sn-field-info sn-title="Cc" sn-text="mailData.cc" ng-show="mailData.cc"></sn-field-info>
                                    <sn-field-info sn-title="Date" sn-text="mailData.date | date:dateFilterJobMail"></sn-field-info>
                                    <sn-field-info sn-title="Email template" sn-text="mailData.name"></sn-field-info>
                                    <sn-field-info sn-title="Subject" sn-text="mailData.subject"></sn-field-info>
                                    <sn-field-info sn-title="Message" ng-show="mailData.status !== null" sn-html="mailData.text" class="mail-unstyled"></sn-field-info>
                                    <sn-field-info sn-title="Message" ng-show="mailData.status === null" sn-html="mailData.emailTextReply" class="mail-unstyled"></sn-field-info>
                               </div>
                              
                               <div class="modal-footer modal-foot" ng-show="mailData.status === null && mailData.validMsg === true && !isLeadArchived">
                                    <button type="submit" ng-click="replySendMail($event, mailData)" class="btn btn-success btn-lg">Reply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>`,

			replace: true,
			transclude: true,
			link(scope) {
				$(document).on('show.bs.modal', '#mailInfoModal', () => {
					settingsService.timeFormatSettings.subscribe(data => {
						scope.dataFormatMonth = data.dateFormat;
						scope.dataTimeFormat = data.timeFormat;
						scope.DateFormatFilter =
							scope.dataFormatMonth === 'DD_MM_YYYY'
								? 'dd MMMM yyyy'
								: 'MMMM dd yyyy';
						scope.timeFormatFilter =
							scope.dataTimeFormat === 'T_24' ? 'HH:mm' : 'h:mm a';

						scope.dateFilterJobMail = `${scope.DateFormatFilter} 'at' ${
							scope.timeFormatFilter
						}`;
					});
				});

				scope.replySendMail = event => {
					scope.onReplySend({ event });
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/helperSubscription/mailInfoModal.js